export default __webpack_public_path__ + "static/media/no-plan.fb2e63da.png";